export const signIn = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({
          type: "SIGN_IN",
        });
      })
      .catch((err) => {
        dispatch({
          type: "SIGN_IN_ERR",
          err,
        });
      });
  };
};

export const signUp = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .auth()
      .createUserWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        return getFirebase()
          .auth()
          .currentUser.updateProfile({
            displayName: creds.name,
          })
          .then(() => {
              const newState = {...getState()}
              newState.firebase.auth.displayName = creds.username;
            dispatch({
              type: "SIGN_UP",
              newState
            });
          })
          .catch((err) => {
            dispatch({
              type: "SIGN_UP_ERR",
              err,
            });
          });
      })
      .catch((err) => {
        dispatch({
          type: "SIGN_UP_ERR",
          err,
        });
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .auth()
      .signOut()
      .then(() => {
        dispatch({
          type: "SIGN_OUT",
        });
      })
      .catch((err) => {
        dispatch({
          type: "SIGN_OUT_ERR",
          err,
        });
      });
  };
};

export const signInProvider = (provider) => {
  return (dispatch, getState, { getFirebase }) => {
   
    return getFirebase()
      .login({ provider, type: 'popup' })
      .then(() => {
        dispatch({
          type: "SIGN_IN_PROVIDER"
        });
      })
      .catch((err) => {
        dispatch({
          type: "SIGN_IN_PROVIDER_ERR",
          err,
        });
      });
  };
}
